module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-star-e4d8f46f96b5bf57336d81b30f338b11.svg";